import { render, staticRenderFns } from "./SwitchDarkMode.vue?vue&type=template&id=c6e2c4fc&scoped=true"
import script from "./SwitchDarkMode.vue?vue&type=script&lang=js"
export * from "./SwitchDarkMode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6e2c4fc",
  null
  
)

export default component.exports